var callBind = {exports: {}};

export { callBind as __module };
